/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateAccountStatus } from './UpdateAccountStatus';
import {
    UpdateAccountStatusFromJSON,
    UpdateAccountStatusFromJSONTyped,
    UpdateAccountStatusToJSON,
} from './UpdateAccountStatus';

/**
 * 
 * @export
 * @interface UpdateAccountStatusOutput
 */
export interface UpdateAccountStatusOutput {
    /**
     * 
     * @type {UpdateAccountStatus}
     * @memberof UpdateAccountStatusOutput
     */
    account?: UpdateAccountStatus;
    /**
     * 
     * @type {Error}
     * @memberof UpdateAccountStatusOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the UpdateAccountStatusOutput interface.
 */
export function instanceOfUpdateAccountStatusOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateAccountStatusOutputFromJSON(json: any): UpdateAccountStatusOutput {
    return UpdateAccountStatusOutputFromJSONTyped(json, false);
}

export function UpdateAccountStatusOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountStatusOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': !exists(json, 'account') ? undefined : UpdateAccountStatusFromJSON(json['account']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function UpdateAccountStatusOutputToJSON(value?: UpdateAccountStatusOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': UpdateAccountStatusToJSON(value.account),
        'error': value.error,
    };
}

